"use client"

import type React from "react"
import { motion } from "framer-motion"
import SignatureCanvas from "react-signature-canvas"
import { Card } from "../ui/card-animated"

interface SignatureSectionProps {
  signatureRef: React.RefObject<SignatureCanvas>
  signaturePadContainerRef: React.RefObject<HTMLDivElement>
  handleSignatureEnd: () => void
  handleClearSignature: () => void
}

const slideUp = {
  hidden: { opacity: 0, y: 10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
}

export const SignatureSection: React.FC<SignatureSectionProps> = ({
  signatureRef,
  signaturePadContainerRef,
  handleSignatureEnd,
  handleClearSignature,
}) => {
  return (
    <Card title="Firma" delay={6}>
      <div className="space-y-4">
        <motion.div variants={slideUp} className="flex flex-col space-y-2">
          <label className="text-gray-700 font-medium text-sm">
            Por favor, firme a continuación para aceptar los términos y condiciones
          </label>
          <div
            ref={signaturePadContainerRef}
            className="border border-gray-200 rounded-md overflow-hidden bg-white h-32"
          >
            <SignatureCanvas
              ref={signatureRef}
              onEnd={handleSignatureEnd}
              canvasProps={{
                className: "w-full h-full",
              }}
              backgroundColor="rgba(255, 255, 255, 0)"
              penColor="black"
              velocityFilterWeight={0.7}
            />
          </div>
          <div className="flex justify-end">
            <motion.span
              whileHover={{ color: "#333" }}
              onClick={handleClearSignature}
              className="text-gray-500 text-xs cursor-pointer hover:underline"
            >
              Limpiar firma
            </motion.span>
          </div>
        </motion.div>
      </div>
    </Card>
  )
}
